"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingAndReviewDialog = void 0;
var _dynamic = _interopRequireDefault(require("next/dynamic"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const RatingAndReviewDialogController = (0, _dynamic.default)(async () => (await Promise.resolve().then(() => _interopRequireWildcard(require('@ori/rating-and-review-dialog')))).RatingAndReviewDialogController, {
  ssr: false
});
const RatingAndReviewDialog = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(RatingAndReviewDialogController, {});
exports.RatingAndReviewDialog = RatingAndReviewDialog;
